import React, { useEffect, useState } from 'react'
import { commonCss } from '../CssStyle/commonCss';
import { AppBar, Box, Divider, Grid2, IconButton, Toolbar, Typography } from '@mui/material';
import s2tLogo from "../Images/s2tlogo.png";
import { useNavigate } from 'react-router-dom';
import { Facebook, Instagram, LinkedIn, Twitter } from '@mui/icons-material';

const PolicyRouter = (props) => {
     const [bgColor,setBgColor]=useState(commonCss.blue)

     const navigate=useNavigate()
     const origin=window.location.origin

      const handleScroll = () => {
            if (window.scrollY > 50) {
              setBgColor("white"); // Change to dark color when scrolled down
            } else {
              setBgColor(commonCss.blue); // Change back to transparent when at the top
            }
          };
        
          useEffect(() => {
            window.addEventListener("scroll", handleScroll);
            return () => {
              window.removeEventListener("scroll", handleScroll);
            };
          }, []);
  return (
    <Box>
         <AppBar component="nav" elevation={bgColor!=="white"?0:4} sx={{ padding: "0.5rem",backgroundColor:bgColor }}>
          <Toolbar>
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                color: commonCss.navCompanyNameColor,
                // gap: "0.1rem",
                justifyContent:"center",
                alignItems: "center",
              }}
            >
              <img
                src={s2tLogo}
                alt="s2tlogo"
                style={{ width: "auto", height: "12vh" }}
              />
              <Typography variant="h6" sx={{ color: (bgColor==="white")?commonCss.blue:"white",fontFamily: `-apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, 
      'Helvetica Neue', 'Fira Sans', Ubuntu, Oxygen, 'Oxygen Sans', Cantarell, 
      'Droid Sans', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 
      'Lucida Grande', Helvetica, Arial, sans-serif`,fontWeight:500,mb:-2 }}>
                SOLVER THOUGHTS TECHNOLOGIES
              </Typography>
            </Box>
           
          </Toolbar>
        </AppBar>
        <Box sx={{ mt: "-10vh" }} >
            <Toolbar/>
            <Box sx={{display:'flex',justifyContent:"center"}}>
            {props.children}
            </Box>
        </Box>
        <Grid2 container spacing={"1.5rem"} sx={{ backgroundColor: "#0A66C2", padding: "1.2rem" }} >
    <Grid2
    size={12}
      container
      justifyContent={"center"}
      sx={{ backgroundColor: "transparent" }}
      spacing={"1.5rem"}
    >
      <Grid2 size={12}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              color: commonCss.navCompanyNameColor,
              gap: "0.5rem",
              alignItems: "center",
              width: { xs: "100%", md: "80%" },
            }}
          >
            <img
              src={s2tLogo}
              alt="s2tlogo"
              style={{ width: "autp", height: "11vh" }}
            />
            <Typography variant="h6" sx={{ color: "inherit", mb: -0.8 }}>
              SOLVER THOUGHTS TECHNOLOGIES
            </Typography>
          </Box>
          <Box
            sx={{
              width: { xs: "100%", md: "20%" },
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <IconButton
              sx={{
                ":hover": {
                  color: commonCss.blue,
                  border: 1,
                  borderColor: commonCss.blue,
                },
              }}
            >
              <Facebook />
            </IconButton>
            <IconButton
              sx={{
                ":hover": {
                  color: commonCss.blue,
                  border: 1,
                  borderColor: commonCss.blue,
                },
              }}
            >
              {" "}
              <LinkedIn />
            </IconButton>
            <IconButton
              sx={{
                ":hover": {
                  color: commonCss.blue,
                  border: 1,
                  borderColor: commonCss.blue,
                },
              }}
            >
              <Twitter />
            </IconButton>
            <IconButton
              sx={{
                ":hover": {
                  color: commonCss.blue,
                  border: 1,
                  borderColor: commonCss.blue,
                },
              }}
            >
              <Instagram />
            </IconButton>
          </Box>
        </Box>
      </Grid2>
      <Grid2 size={{ xs: 6, md: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: commonCss.titleWeight,
              position: "relative",
              pt: "15px",
              "::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "20%",
                height: "3px",
                backgroundColor: commonCss.orange,
              },
            }}
          >
            Company
          </Typography>

          {/* <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
          >
            About Us
          </Typography> */}
          {/* <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
          >
            Blog
          </Typography> */}
          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
            onClick={()=>{window.open(`${origin}/policy`,"_blank")}}
          >
            Privacy Policy
          </Typography>
          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
            onClick={()=>{window.open(`${origin}/terms`,"_blank")}}
          >
            Terms and Conditions
          </Typography>
          {/* <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
          >
            FAQ
          </Typography> */}
        </Box>
      </Grid2>
      {/* <Grid2 size={{ xs: 6, md: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: commonCss.titleWeight,
              position: "relative",
              pt: "15px",
              "::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "20%",
                height: "3px",
                backgroundColor: commonCss.orange,
              },
            }}
          >
            Our Solutions
          </Typography>

          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
          >
            Services
          </Typography>
          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
          >
            Products
          </Typography>
          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
          >
            Demo
          </Typography>
          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
          >
            Outsourcing
          </Typography>
          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
          >
            Pricing
          </Typography>
        </Box>
      </Grid2> */}
      <Grid2 size={{ xs: 6, md: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: commonCss.titleWeight,
              position: "relative",
              pt: "15px",
              "::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "20%",
                height: "3px",
                backgroundColor: commonCss.orange,
              },
            }}
          >
            Join Us
          </Typography>

          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
          >
            Career
          </Typography>
          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
            // onClick={()=>{navigate('info@solverthoughts.com')}}
          >
            info@solverthoughts.com
          </Typography>
          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              width:'fit-content',
            //   cursor: "pointer",
            //   ":hover": {
            //     color: commonCss.blue,
            //   },
            }}
          >
            +60 11-6575 8595
          </Typography>
        </Box>
        {/* <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" ,mt:"1.5rem" }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: commonCss.titleWeight,
              position: "relative",
              pt: "15px",
              "::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "20%",
                height: "3px",
                backgroundColor: commonCss.orange,
              },
            }}
          >
            Become a Partner
          </Typography>

          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              cursor: "pointer",
              width:'fit-content',
              ":hover": {
                color: commonCss.orange,
              },
            }}
          >
            Partners
          </Typography>
        </Box> */}
      </Grid2>
      <Grid2 size={{ xs: 6, md: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: commonCss.titleWeight,
              position: "relative",
              pt: "15px",
              "::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                bottom:0,
                width: "20%",
                height: "3px",
                backgroundColor: commonCss.orange,
              },
            }}
          >
            Reach Us
          </Typography>

          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              width:'fit-content',
              cursor: "pointer",
              ":hover": {
                color: commonCss.orange,
              },
            }}
          >
            Contact Us
          </Typography>
          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
              width:'fit-content',
              cursor: "pointer",
              ":hover": {
                color: commonCss.orange,
              },
            }}
          >
            Solver Thoughts Technologies Sdn Bhd BO1-A-9, MENARA 2, KL ECO CITY
            , 3, Jln BANGSAR 59200 KUALA LUMPUR MALAYSIA
          </Typography>
          <Typography
            sx={{
              fontWeight: commonCss.listWeight,
              color: commonCss.listColor,
            //   cursor: "pointer",
              width:'fit-content',
            //   ":hover": {
            //     color: commonCss.blue,
            //   },
            }}
          >
            +60 11-6575 8595
          </Typography>
        </Box>
      </Grid2>
    </Grid2>
    <Grid2 size={12}>
      <Divider sx={{
    borderStyle: 'dotted',
    borderWidth: '2px',
    borderColor: "#B8B8B8"
  }} />
      <Box sx={{width:"100%",pt:"1rem"}}>
      <Typography textAlign={"center"} sx={{color:"#B8B8B8"}}>© {new Date().getFullYear()}, Solver Thoughts Technologies.</Typography>
      </Box>
    </Grid2>
    </Grid2>
    </Box>
  )
}

export default PolicyRouter